document.addEventListener("DOMContentLoaded", function () {
  var bundleSwiper = new Swiper(".diy-bundle-list ", {
    slidesPerView: 3,
    observer: true,
    observeParents: true,
    resizeObserver: true,
    preventClicks: true,
    slideToClickedSlide: false,
    threshold: 30,
    autoplay: {
      pauseOnMouseEnter: true,
    },
    grid: {
      rows: 2,
    },
    spaceBetween: 16,
    pagination: {
      el: ".diy-bundle-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".diy-bundle-next",
      prevEl: ".diy-bundle-pre",
    },
    on: {
      click: function (swiper, event) {
        if (event.target.tagName === "A") {
          window.location.href = event.target.href;
        }
      },
    },
    breakpoints: {
      1000: {
        slidesPerView: 3,
        spaceBetween: 16,
        grid: {
          rows: 2,
        },
      },
      769: {
        slidesPerView: 3,
        spaceBetween: 8,
        grid: {
          rows: 2,
        },
      },
      0: {
        slidesPerView: 2,
        spaceBetween: 8,
        grid: {
          rows: 2,
        },
      },
    },
  });

  // 存储已选产品（格式: {slot: 位置, product: 产品信息, uniqueId: 唯一标识}）
  let selectedProducts = [];
  const MAX_SLOTS = 4; // 固定4个位置
  let uniqueIdCounter = 0; // 唯一标识计数器

  const addToCartBtn = document.querySelector(".add-cart-btn");
  const addToCartBtnPrice = addToCartBtn.querySelector(".total-price");
  const discount = addToCartBtn.dataset.discount;

  // 从DOM中动态提取产品信息（核心修改：不再依赖固定数组）
  function getProductFromDOM(productId) {
    const productEl = document.querySelector(
      `.diy-bundle-product[data-id="${productId}"]`
    );
    if (!productEl) return null;

    // 提取产品信息
    return {
      id: productId,
      name: productEl.querySelector(".bundle-pro-title").textContent.trim(),
      price: parsePrice(
        productEl.querySelector(".bundle-pro-original-price").textContent
      ),
      image: productEl.querySelector(".bundle-pro-img").src,
      variant: productEl.dataset.variant,
    };
  }

  // 初始化：监听左侧产品的添加按钮
  document.querySelectorAll(".add-to-set").forEach((button) => {
    button.addEventListener("click", function () {
      const productId = parseInt(
        this.closest(".diy-bundle-product").dataset.id
      );
      addToSet(productId);
    });
  });

  // 添加产品到套装（找到第一个空位置，允许重复添加）
  function addToSet(productId) {
    if (selectedProducts.length >= MAX_SLOTS) {
      return;
    }

    // 动态从DOM获取产品信息
    const product = getProductFromDOM(productId);
    if (!product) return;

    // 找到第一个空位置
    const emptySlot = getFirstEmptySlot();
    if (emptySlot) {
      uniqueIdCounter++; // 生成唯一标识
      // 添加到已选列表
      selectedProducts.push({
        slot: parseInt(emptySlot.dataset.slot),
        product: product,
        uniqueId: uniqueIdCounter, // 用于区分重复产品
      });

      // 更新UI（传递唯一标识）
      renderSelectedProduct(emptySlot, product, uniqueIdCounter);
      updateTotalPrice();
    }
  }

  // 获取第一个空位置
  function getFirstEmptySlot() {
    for (let i = 1; i <= MAX_SLOTS; i++) {
      const slot = document.querySelector(`.bundle-slot[data-slot="${i}"]`);
      if (slot.classList.contains("empty")) {
        return slot;
      }
    }
    return null;
  }

  // 渲染已选产品到指定位置（增加唯一标识参数）
  function renderSelectedProduct(slotElement, product, uniqueId) {
    // 移除按钮携带uniqueId，而非product.id
    slotElement.innerHTML = `
                <button class="remove" data-uniqueid="${uniqueId}">×</button>
                <img src="${product.image}" alt="${product.name}" class="slot-pro-img">
                <p class="slot-pro-title">${product.name}</p>
            `;
    slotElement.classList.remove("empty");
    slotElement.classList.add("filled");

    // 移除事件：根据uniqueId删除
    const removeBtn = slotElement.querySelector(".remove");
    removeBtn.addEventListener("click", function () {
      const targetUniqueId = parseInt(this.dataset.uniqueid);
      removeFromSet(targetUniqueId);
    });
  }

  // 从套装中移除产品（根据uniqueId删除，支持删除重复产品）
  function removeFromSet(targetUniqueId) {
    // 找到要移除的产品（根据uniqueId）
    const index = selectedProducts.findIndex(
      (item) => item.uniqueId === targetUniqueId
    );
    if (index === -1) return;

    const removedItem = selectedProducts.splice(index, 1)[0];

    // 清空对应位置
    const slot = document.querySelector(
      `.bundle-slot[data-slot="${removedItem.slot}"]`
    );
    if (slot) {
      slot.innerHTML = `<div class="add-icon">+</div>`;
      slot.classList.add("empty");
      slot.classList.remove("filled");
    }

    // 更新总价
    updateTotalPrice();
  }

  // 更新总价
  function updateTotalPrice() {
    // 累加所有已选产品价格
    const total = selectedProducts.reduce((sum, item) => {
      return sum + item.product.price;
    }, 0);

    let finalPrice = total;

    console.log(selectedProducts);

    const variantStr = selectedProducts
      .map((item) => item.product.variant)
      .join(",");

    if (selectedProducts.length >= 2) {
      finalPrice = total * discount;
    }

    if (selectedProducts.length >= 1) {
      addToCartBtn.removeAttribute("disabled");
    } else {
      addToCartBtn.setAttribute("disabled", "disabled");
    }

    addToCartBtnPrice.textContent = `$${finalPrice.toFixed(2)}`;
    addToCartBtn.dataset.variantId = variantStr;
  }

  // 解析价格
  function parsePrice(priceText) {
    // 1. 先移除所有非数字、非小数点和非逗号的字符
    let cleaned = priceText.replace(/[^0-9.,]/g, ""); // 2. 统计小数点和逗号的数量
    const dotCount = (cleaned.match(/\./g) || []).length;
    const commaCount = (cleaned.match(/,/g) || []).length; // 3. 根据逗号和小数点的数量决定如何处理
    if (commaCount > 0) {
      if (dotCount === 0) {
        // 情况1：只有逗号（如 "1,234" 或 "1,23"）
        // 将最后一个逗号替换为小数点，其他逗号视为千位分隔符
        const lastCommaIndex = cleaned.lastIndexOf(",");
        cleaned =
          cleaned.substring(0, lastCommaIndex) +
          "." +
          cleaned.substring(lastCommaIndex + 1);
        cleaned = cleaned.replace(/,/g, ""); // 移除其他逗号
      } else {
        // 情况2：既有逗号又有小数点（如 "1,234.56"）
        // 直接移除逗号
        cleaned = cleaned.replace(/,/g, "");
      }
    } // 4. 处理多个小数点的情况（保留最后一个小数点）
    cleaned = cleaned.replace(/\.(?=.*\.)/g, ""); // 5. 转换为数字，无效时返回0
    return Number(cleaned) || 0;
  }

  updateTotalPrice();
});
